/**
 * Desktop-only sidebar. Hidden on mobile (md:breakpoint).
 * Renders the main Sidebar inside a flex container.
 */
import type { ComponentProps } from "react";
import Sidebar from "./Sidebar";

type SidebarDesktopProps = ComponentProps<typeof Sidebar>;

export default function SidebarDesktop(props: SidebarDesktopProps) {
  return (
    <aside
      className="hidden md:flex no-print sticky top-0 self-stretch h-[100dvh] max-h-[100dvh] flex-shrink-0 border-r border-border bg-card flex-col m-0 p-0 relative z-10"
      aria-hidden="false"
    >
      <Sidebar {...props} />
    </aside>
  );
}
